import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 relative overflow-hidden">
      {/* Subtle background animation */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-800/20 to-transparent pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Section - Links */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {/* Products */}
              <div className="group">
                <h4 className="font-bold text-lg mb-4 transition-all duration-300 group-hover:text-orange-400 group-hover:scale-105">Products</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/switch" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">UPI Switch</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/paymentSolutions" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">PG Solution</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/Recon" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Reconciliation</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/Merchant" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Merchant Management</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/PayoutProcessLanding" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Payout Solutions</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/NETC" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">NETC Solution</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/IssuerDashboard" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">NETC Issuer</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/HubLiveLanding" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Video Communication</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/dms" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Document Management System</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                </ul>
              </div>

              {/* Services */}
              <div className="group">
                <h4 className="font-bold text-lg mb-4 transition-all duration-300 group-hover:text-orange-400 group-hover:scale-105">Services</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/staff-augmentation" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Engagement Models</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/cloud" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Cloud Offerings</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/cybersecurity" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Cyber Security</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/data-analytics" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Data Analytics</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/industry" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Serving Industries</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/payxlanding" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">HealthCare Services</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/app-services" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Application Development</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                  {/* <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/developer" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Developer Documentation</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li> */}
                </ul>
              </div>

              {/* About */}
              <div className="group">
                <h4 className="font-bold text-lg mb-4 transition-all duration-300 group-hover:text-orange-400 group-hover:scale-105">About Us</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/Aboutus" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">About Us</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/Careers" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Careers</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/Contact" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Contact</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                  <li className="transform transition-all duration-300 hover:translate-x-2 hover:scale-105">
                    <a href="/clients" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                      <span className="relative z-10">Clients</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                    </a>
                  </li>
                </ul>
              </div>

              {/* Contact */}
              <div className="group">
                <h4 className="font-bold text-lg mb-4 transition-all duration-300 group-hover:text-orange-400 group-hover:scale-105">How Can We Help?</h4>
                <div className="text-sm text-gray-300 space-y-2">
                  <div className="transform transition-all duration-300 hover:translate-x-1 hover:scale-105 p-2 rounded hover:bg-gray-800/50">
                    <p>
                      <strong className="text-white">Phone:</strong><br />
                      <span className="hover:text-orange-400 transition-colors duration-300"><a href="tel:+918425930405">+91 8425930405</a></span>
                    </p>
                  </div>
                  <div className="transform transition-all duration-300 hover:translate-x-1 hover:scale-105 p-2 rounded hover:bg-gray-800/50">
                    <p>
                      <strong className="text-white">Email:</strong><br />
                      <a href="mailto:renu@anvitechsolutions.com" className="hover:text-orange-400 transition-colors duration-300 relative inline-block">
                        <span className="relative z-10">admin@anvitechsolutions.com</span>
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                      </a>
                    </p>
                  </div>
                  <div className="transform transition-all duration-300 hover:translate-x-1 hover:scale-105 p-2 rounded hover:bg-gray-800/50">
                    <p>
                      <strong className="text-white">Business Hours:</strong><br />
                      <span className="hover:text-orange-400 transition-colors duration-300">
                        10:30 am – 7:30 pm<br />
                        Monday – Friday
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Brand and Social */}
          <div className="lg:col-span-1">
            <div className="text-center lg:text-left">
              <h4 className="font-bold text-lg mb-6 transition-all duration-300 hover:text-orange-400 hover:scale-105">Find Us Here</h4>

              {/* Logo */}
              <div className="mb-6 transform transition-all duration-500 hover:scale-110 hover:rotate-1">
                <img src="./logo.png" alt="AnviTech Solutions" className="w-64 h-auto filter transition-all duration-300 hover:brightness-110 hover:drop-shadow-lg" />
              </div>

              {/* Social Links */}
              <div className="flex justify-center lg:justify-start space-x-4 mb-6">
                {/* <a
                  href="https://www.facebook.com/AnviTechSolutionsLLP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-all duration-300 transform hover:scale-125 hover:rotate-12 hover:shadow-lg"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/en/thumb/0/04/Facebook_f_logo_%282021%29.svg/1024px-Facebook_f_logo_%282021%29.svg.png"
                    alt="Facebook"
                    className="w-4 h-4 transition-all duration-300 hover:scale-110"
                  />
                </a> */}
                <a
                  href="https://in.linkedin.com/company/anvitechsolutions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-all duration-300 transform hover:scale-125 hover:rotate-12 hover:shadow-lg"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/960px-LinkedIn_logo_initials.png"
                    alt="LinkedIn"
                    className="w-4 h-4 transition-all duration-300 hover:scale-110"
                  />
                </a>
              </div>

              {/* Legal Links */}
              <div className="text-sm text-gray-400 space-y-2">
                <p className="transition-all duration-300 hover:text-gray-300">&copy; 2025 Anvitech Solutions - All Rights Reserved.</p>
                <div className="space-x-2">
                  <a href="/careers" className="hover:text-orange-400 transition-all duration-300 transform hover:scale-110 inline-block relative">
                    <span className="relative z-10">Careers</span>
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                  </a>
                  <span className="transition-all duration-300 hover:text-gray-300">|</span>
                  <a href="/termsUse" className="hover:text-orange-400 transition-all duration-300 transform hover:scale-110 inline-block relative">
                    <span className="relative z-10">Terms of Use</span>
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                  </a>
                  <span className="transition-all duration-300 hover:text-gray-300">|</span>
                  <a href="/privacyPolicy" className="hover:text-orange-400 transition-all duration-300 transform hover:scale-110 inline-block relative">
                    <span className="relative z-10">Privacy Policy</span>
                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 hover:w-full"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;